'use strict';

var translations = {
    warnings: {
        straightRow: 'หลีกเลี่ยงอักขระที่อยู่เรียงกันบนแป้นพิมพ์ เช่น asdf',
        simpleRepeat: 'หลีกเลี่ยงคำหรืออักขระซ้ำ เช่น aaa, abcabc',
        extendedRepeat: 'หลีกเลี่ยงคำหรืออักขระซ้ำ เช่น aaa, abcabc',
        sequences: 'หลีกเลี่ยงอักขระหรือตัวเลขที่เรียงกัน เช่น abc, 6543',
        recentYears: 'หลีกเลี่ยงปีเมื่อไม่นานมานี้ เช่น 2020',
        dates: 'หลีกเลี่ยงวันที่',
        topTen: 'หลีกเลี่ยงรหัสผ่านที่มักใช้กันทั่วไป',
        topHundred: 'หลีกเลี่ยงรหัสผ่านที่มักใช้กันทั่วไป',
        common: 'หลีกเลี่ยงรหัสผ่านที่มักใช้กันทั่วไป',
        similarToCommon: 'หลีกเลี่ยงรหัสผ่านที่มักใช้กันทั่วไป',
        wordByItself: 'หลีกเลี่ยงการตั้งรหัสผ่านด้วยคำๆ เดียว',
        namesByThemselves: 'หลีกเลี่ยงการตั้้งรหัสผ่านด้วยชื่อและนามสกุล',
        commonNames: 'หลีกเลี่ยงการตั้้งรหัสผ่านด้วยชื่อและนามสกุล',
        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: 'ตั้งรหัสผ่านที่ยาวเกินสองคำ หลีกเลี่ยงการใช้คำทั่วไป',
        anotherWord: 'เพิ่มอีกคำหรือสองคำ ควรใช้คำที่ไม่ใช่คำทั่วไป',
        repeated: 'หลีกเลี่ยงคำหรืออักขระซ้ำ เช่น aaa, abcabc',
        l33t: 'หลีกเลี่ยงการใช้อักขระพิเศษที่คาดเดาได้ง่ายแทนอักขระบางตัว เช่น @ แทน a (อย่าง @pple แทน Apple)',
        reverseWords: 'หลีกเลี่ยงการกลับลำดับอักขระ เช่น elppa (กลับลำดับจาก apple)',
        allUppercase: 'การใช้ตัวพิมพ์ใหญ่ทั้งหมดช่วยให้เดาได้ง่ายแทบไม่ต่างจากตัวพิมพ์เล็กทั้งหมด',
        dates: 'หลีกเลี่ยงวันที่',
        associatedYears: 'หลีกเลี่ยงวันที่',
        recentYears: 'หลีกเลี่ยงปีเมื่อไม่นานมานี้ เช่น 2020',
        sequences: 'หลีกเลี่ยงอักขระหรือตัวเลขที่เรียงกัน เช่น abc, 6543',
        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
